var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.586 26.93H5.413a1.638 1.638 0 01-1.661-1.61V6.04a1.639 1.639 0 011.661-1.61h19.173a1.641 1.641 0 011.666 1.61v19.28a1.64 1.64 0 01-1.666 1.61zm-6.883-11.398c1.125 0 1.723.795 1.723 2.3v5.433h3.4V17.44c0-2.863-1.464-4.571-3.915-4.571a3.364 3.364 0 00-3.063 1.677v-1.441h-3.397c.035.779.012 7.221 0 9.955v.206h3.397v-5.674c-.015-.28.023-.56.113-.825a1.89 1.89 0 011.742-1.235zm-10.53-2.427v10.16h3.398v-10.16H7.173zm1.723-4.898a1.761 1.761 0 10-.048 3.51h.021a1.762 1.762 0 10.027-3.51z",
    fill: "#D9D9D9"
  })));
}
export default __webpack_public_path__ + "assets/static/media/linkedin.9db44af6.svg";
export { SvgLinkedin as ReactComponent };